var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1062.000000pt",
    height: "258.000000pt",
    viewBox: "0 0 1062.000000 258.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,258.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1080 1330 l0 -510 75 0 75 0 0 510 0 510 -75 0 -75 0 0 -510z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 1765 l0 -75 75 0 75 0 0 75 0 75 -75 0 -75 0 0 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493 1604 c-70 -75 -129 -142 -131 -149 -3 -11 14 -15 65 -17 l68 -3 5 -226 5 -226 30 -49 c54 -86 116 -114 253 -114 l82 0 0 64 0 63 -63 5 c-35 3 -77 13 -95 22 -57 29 -62 53 -62 271 l0 195 110 0 110 0 0 65 0 65 -110 0 -110 0 0 85 c0 66 -3 85 -14 85 -8 0 -72 -61 -143 -136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 1571 c-95 -23 -197 -111 -242 -209 -34 -75 -43 -214 -18 -294 77 -244 376 -346 591 -203 27 19 53 31 57 29 4 -3 8 -21 8 -40 l0 -34 65 0 65 0 0 375 0 375 -59 0 c-63 0 -70 -7 -71 -67 0 -29 -2 -29 -51 7 -68 49 -139 70 -232 69 -45 -1 -96 -4 -113 -8z m247 -162 c92 -51 144 -168 119 -268 -26 -104 -87 -166 -187 -190 -105 -25 -214 22 -270 116 -24 41 -28 59 -28 123 1 123 59 203 175 241 45 15 145 3 191 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2603 1562 c-103 -37 -170 -100 -220 -209 -24 -50 -27 -71 -28 -153 0 -113 12 -159 64 -237 46 -68 126 -125 210 -150 110 -32 259 -5 347 62 18 14 35 25 37 25 2 0 7 -18 11 -40 l6 -40 60 0 60 0 0 375 0 375 -59 0 -59 0 -6 -45 c-8 -48 -16 -54 -37 -29 -7 9 -40 30 -73 47 -54 27 -72 31 -161 34 -78 3 -111 -1 -152 -15z m238 -137 c24 -9 59 -30 77 -48 140 -134 88 -369 -92 -422 -66 -20 -95 -19 -158 5 -120 45 -184 160 -158 284 31 148 185 232 331 181z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 1195 l0 -375 75 0 75 0 0 375 0 375 -75 0 -75 0 0 -375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3317 963 c-4 -3 -7 -37 -7 -75 l0 -68 75 0 75 0 0 75 0 75 -68 0 c-38 0 -72 -3 -75 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bc23aef5cb2c64adeb5007fb184aeaf9.svg";
export { ForwardRef as ReactComponent };